import * as React from 'react';

import ManufacturersTable from './ManufacturersTable';

export default class Manufacturers extends React.Component {
  
  state = {
    loading: false,
    status: 'pending',
    searchQuery: ''
  };

  public componentDidMount() {
    if ((this.props as any).onCollapse) {
      (this.props as any).onCollapse(false);
    }
  }

  constructor(props: any) {
    super(props);
  }

  public render() {
    return (
      <div>
        <ManufacturersTable />
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/scenes/Manufacturers/index.tsx